import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import InitialPage from './components/InitialPage';
import LoginPage from './pages/LoginPage';
import MenuPage from './pages/MenuPage';
import AdvanceReport from './pages/AdvanceReport';
import AiReportDisplay from './pages/AiReportDisplay';
import Dashboard from './pages/Dashboard';
import ForceLoginPage from './pages/ForceLoginPage';
import SessionExpiredPage from './pages/SessionExpiredPage';
import ThemeProvider from './components/ThemeProvider';
import AuthSessionGuard from "./components/AuthSessionGuard";
import useRouteTitle from './hooks/useRouteTitle';
import './App.css';

function RouteTitleSetter() {
  useRouteTitle();
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <RouteTitleSetter />

        {/* 🔓 PUBLIC / UNGUARDED ROUTES */}
        <Routes>
          <Route path="/" element={<InitialPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forcelogin" element={<ForceLoginPage />} />
          <Route path="/session-expired" element={<SessionExpiredPage />} />
        </Routes>

        {/* 🔐 PROTECTED ROUTES */}
       {/* <AuthSessionGuard> */}
          <Routes>
            <Route path="/explorer" element={<MenuPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/advance-report" element={<AdvanceReport />} />
            <Route path="/ai-report-display" element={<AiReportDisplay />} />
          </Routes>
        {/* </AuthSessionGuard> */}

      </Router>
    </ThemeProvider>
  );
}

export default App;
